import React from 'react'
import { ReactComponent as UpcomingArrows } from '../../assets/svg/upcomingArrows.svg'
import Loading from '../Loading'

/**
 * Floating pill button with a count badge. Shared by the dashboard triggers
 * and the close button inside the content panels, so the close button lands
 * exactly where the trigger was.
 *
 * The badge box is fixed-size, so spinner -> number never shifts layout, and
 * the count span is keyed so a changed count replays a small pop.
 */
function FabButton({ id, label, count = 0, loading = false, onClick, icon: Icon = UpcomingArrows, textClassName = 'text-white', className = '' }) {
    return (
        <button
            type="button"
            id={id}
            className={`dsh-fab font-bold bg-deepPurple rounded-3xl py-[0.8rem] px-5 flex items-center ${textClassName} ${className}`}
            onClick={onClick}
            aria-label={loading ? label : `${label}: ${count}`}
        >
            <Icon aria-hidden="true" />
            <span className="dsh-fab-label ml-3">{label}</span>
            <span
                className="dsh-fab-badge w-[30px] h-[30px] rounded-full bg-highlightColor border border-white text-deepPurple flex items-center justify-center"
                aria-hidden="true"
            >
                {loading ? (
                    <Loading primaryColor="#5E639B" secondaryColor="#5E639B" size={18} stroke={8} />
                ) : (
                    <span key={count} className="dsh-badge-count">
                        {count}
                    </span>
                )}
            </span>
        </button>
    )
}

export default FabButton
